// src/SearchResultsSort.tsx
import Box from "@mui/material/Box/index.js";
import FormControl from "@mui/material/FormControl/index.js";
import InputLabel from "@mui/material/InputLabel/index.js";
import Select from "@mui/material/Select/index.js";
import MenuItem from "@mui/material/MenuItem/index.js";
import { useTranslation } from "react-i18next";
import { jsx, jsxs } from "react/jsx-runtime";
var SearchResultsSort = ({
  sortKey,
  onChange
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx(Box, { sx: { minWidth: 200 }, children: /* @__PURE__ */ jsxs(FormControl, { size: "small", fullWidth: true, children: [
    /* @__PURE__ */ jsx(InputLabel, { id: "search-results-sort-label", children: t("searchResults.sortLabel") }),
    /* @__PURE__ */ jsxs(
      Select,
      {
        labelId: "search-results-sort-label",
        label: t("searchResults.sortLabel"),
        value: sortKey,
        onChange: (event) => onChange(event.target.value),
        children: [
          /* @__PURE__ */ jsx(MenuItem, { value: "relevance", children: t("searchResults.sortRelevance") }),
          /* @__PURE__ */ jsx(MenuItem, { value: "name_asc", children: t("searchResults.sortNameAsc") })
        ]
      }
    )
  ] }) });
};

export {
  SearchResultsSort
};
